"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreColumnChart = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreColumnChart = /** @class */ (function (_super) {
    tslib_1.__extends(CoreColumnChart, _super);
    function CoreColumnChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreColumnChart.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "column" }, this.props));
    };
    return CoreColumnChart;
}(react_1.default.PureComponent));
exports.CoreColumnChart = CoreColumnChart;
//# sourceMappingURL=CoreColumnChart.js.map